"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reset = exports.activateAccount = void 0;
var account_activation_1 = require("@pbl/pbl-react-core/lib/models/account-activation");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var activateAccount = function (key) { return ({
    type: account_activation_1.ACTIVATE_ACCOUNT,
    payload: services_1.AccountService.activateAccount(key)
}); };
exports.activateAccount = activateAccount;
var reset = function () { return ({
    type: account_activation_1.RESET
}); };
exports.reset = reset;
//# sourceMappingURL=actions.js.map